import React, { useEffect, useState } from "react";
import { BATCH_OPTIONS } from "../../config";
import TotalCount from "./TotalCount";
import Graph from "./Graph";
import StudentTable from "./StudentTable";
import Banner from "../Common/Banner";
import DynamicPieChart from "./DynamicPieChart";
import { Stack } from "@mui/system";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Loader from "../Common/Loader";
import SnackbarComponent from "../Common/SnackbarComponent";
import api from '../Auth/Middleware'
import { FormControl, InputLabel, Select, MenuItem,  } from '@mui/material';

export default function AdminDashboard() {
  const [totalStudents, setTotalStudents] = useState(0);
  const [byClassData, setByClassData] = useState([]);
  const [byMonthData, setByMonthData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [totalEarning, setTotalEarning] = useState(0);
  const [pendingAmount, setpendingAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarMsg, setSnackbarMSg] = useState("");
  const [snackbarSevierty, setSnackbarSevierty] = useState("success");
  const [batch, setBatch] = useState(parseInt(sessionStorage.getItem("selectedBatch")) || 2026);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const navigate = useNavigate();

  const handleAddStudent = () => {
    navigate("/addStudent");
  };


  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await api.get(`student/AllStudent?batch=${batch}`);
        setIsLoading(false);
        if (response) {
          setTotalStudents(response.data?.totalStudents);
          handlePieData(response.data?.studentGroupbyClass);
          handleBarData(response.data?.studentGroupbyMonth);
          setStudentData(response.data?.students);
        }
      } catch (error) {
        // Handle error
        setSnackbarOpen(true);
        setSnackbarMSg("Something went Wrong!! Please refresh the page");
        setSnackbarSevierty("error");
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batch]);

  const fetchEarnings = async () => {
    try {
      const response = await api.get(`Student/Earning?batch=${batch}`);
      setTotalEarning(response.data?.paidAmountSum);
      setpendingAmount(
        response.data?.totalAmountSum - response.data?.paidAmountSum
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchEarnings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batch]);

  const handlePieData = (data) => {
    const PieData = data.map((obj) => ({
      label: `${obj.class}th`,
      value: obj.count,
    }));
    setByClassData(PieData);
  };

  const monthNames = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const handleBarData = (data) => {
    const sortedData = data.sort((a, b) => a.month - b.month);
    const transformedArray = sortedData.map((obj) => ({
      month: monthNames[obj.month],
      yValue: obj.numberOfStudents,
    }));
    setByMonthData(transformedArray);
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleAddTeacher = () =>{
    navigate("/addTeacher");
  }

  return (
    <>
      <SnackbarComponent
        open={snackbarOpen}
        severity={snackbarSevierty}
        message={snackbarMsg}
        onClose={closeSnackbar}
      ></SnackbarComponent>
      <Banner title="Admin Dashboard" currentpage="Admin Dashboard" />
      <div className="container">
        <div className="row">
          <div className="mt-4">
            <FormControl fullWidth>
              <InputLabel id="batch-select-label">Select Batch</InputLabel>
              <Select
              labelId="batch-select-label"
              value={batch}
              onChange={(e) => { setBatch(e.target.value); sessionStorage.setItem("selectedBatch", e.target.value); }}
              label="Select Batch"
              >
              {BATCH_OPTIONS.map((b) => (
                <MenuItem key={b} value={b}>{b}</MenuItem>
              ))}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-6 col-sm-12">
            {isLoading ? <Loader /> : <Graph data={byMonthData} label={"Students Registered - By Month"} xlabel={"Students"} ylabel={"Months"}/>}
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                {isLoading ? (
                  <Loader />
                ) : (
                  <TotalCount
                    msg={`Total Fees Submitted`}
                    count={totalEarning}
                    isFees={true}
                  />
                )}
              </div>
              <div className="col-md-6 col-sm-12">
                {isLoading ? (
                  <Loader />
                ) : (
                  <TotalCount
                    msg={`Pending Amount`}
                    count={pendingAmount}
                    isFees={true}
                  />
                )}
              </div>
              <div className="col-md-12 col-sm-12">
                {isLoading ? (
                  <Loader />
                ) : (
                  <DynamicPieChart data={byClassData} label={"Student Registered - By Class"} dataLabel={"Students"} Total={`Total Student ${totalStudents}`}/>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddStudent}
            >
              Add New Student
            </Button>
            <Button variant="contained" color="secondary" onClick={handleAddTeacher}>
              Add Teacher
            </Button>
          </Stack>
        </div>

        <div className="row my-5">
          <div className="col-md-12">
            <StudentTable data={studentData} batch={batch} onWithdraw={fetchEarnings} />
          </div>
        </div>
      </div>
    </>
  );
}
